import { css } from 'styled-components';
import { COLORS } from '../../../../shared/design/tokens';

const styles = {
  container: css`
    width: 929px;
  `,
  invoiceContainer: css`
    display: flex;
    flex-direction: row;
  `,
  invoiceInfoContainer: css`
    display: flex;
    flex-direction: column;
    width: 608px;
    border: 0.5px solid rgba(243, 244, 246, 0.4);
    border-radius: 0 0 0 2px;
    background-color: #ffffff;
    padding: 30px 32px 40px 32px;
  `,
  billingContainer: css`
    width: 321px;
    border: ${({ name }) => (!name ? '0px' : '0.5px')} 0.5px 0.5px 0.5px solid
      rgba(243, 244, 246, 0.4);
    border-radius: 0 0 0 2px;
    background-color: #EEF5FF;
    padding: 30px 32px 40px 32px;
  `,
  billingSection: css`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  `,
  billingTitle: css`
    margin-bottom: 4px;
  `,
  titleContainer: css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 8px;
    margin-top: 16px;
  `,
  title: css`
    min-width: 100px;
  `,
  descriptionCointainer: css`
    display: flex;
    text-align: left;
  `,
  description: css`
    text-align: left;
  `,
  rowContainer: css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  `,
  priceContainer: css`
    width: 101px;
    text-align: left;
  `,
  totalValueContainer: css`
    text-align: left;
  `,
  totalContainer: css`
    margin-top: 32px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-top: 2px solid ${COLORS.TEXT.SEA_BLUE};
    border-bottom: 2px solid ${COLORS.TEXT.SEA_BLUE};
    padding: 17px 0;
  `,
  billingLabel: css`
    ${({ nopadding }) => (nopadding ? '' : `margin-top: 16px;`)}
  `,
  agreeTermsLink: css`
    color: ${COLORS.TEXT.SEA_BLUE};
    font-size: 16px;

    &:hover {
      color: ${COLORS.TEXT.SEA_BLUE};
      opacity: 0.6;
    }
  `
};

export default styles;
